import { createBrowserHistory } from 'history';

if (!window.history) {
  window.history = [];
}

const history = createBrowserHistory({
  basename: window.equicareLocalConfiguration ?
    window.equicareLocalConfiguration.publicPath :
    '',
});

export default history;
